var Acr = Acr || {};

Acr.SignUp = function () {
  var $signUp;
  var $signUpForm;
  var $signUpBody;
  var $signUpProcessing;
  var $signUpResponse;
  var $signUpResponseCopy;
  var $signUpFormInputs;
  var $signUpFormCheckboxes;
  var $signUpSubmitBtn;
  var $signUpZipCodeInput;
  var $signUpZipCodeField;
  var $signUpZipCodeFieldError;
  var $dynamicModelTracking;
  const formSelectorClass = '.js-acr-sign-up-form';
  const bodySelectorClass = '.js-acr-sign-up-body';
  const processingSelectorClass = '.js-acr-sign-up-processing';
  const responseSelectorClass = '.js-acr-sign-up-response';
  const responseCopySelectorClass = '.js-acr-sign-up-copy';
  const inputSelectorClass = '.js-acr-sign-up-input';
  const checkboxSelectorClass = '.js-acr-sign-up-checkbox';
  const submitBtnSelectorClass = '.js-acr-sign-up-submit';
  const requiredClass = 'acr-required';
  const requiredAttr = 'required';
  const conditionalRequiredAttr = 'data-conditional-required';
  const conditionalRequiredCountAttr = 'data-conditional-required-count';
  const formSubmitTracking = 'data-form-submit-tracking';
  const formCheckboxTracking = 'data-form-checkbox-tracking';
  const fieldErrorClass = 'acr-form-element-error';
  const fieldErrorMessage = '.acr-sign-up__error';
  const errorFieldAttr = 'data-error-text';
  const zipCodeRegex = '[zipcode]';

  function sendSuccessTrackingObject(isSuccess) {
    var stringObject = $signUpSubmitBtn.hasAttribute(formSubmitTracking) ? $signUpSubmitBtn.getAttribute(formSubmitTracking) : '';
    if (Acr.TrackingManager && stringObject) {
      try {
        var object = JSON.parse(stringObject.split("'").join('"'));

        if ($dynamicModelTracking && object) {
          object.Model = $dynamicModelTracking.Model;
        }

        if (isSuccess && object) {
          object.dynamic_variables[0].search += ' success';
        }

        Acr.TrackingManager.clickActivity(object);
      } catch (err) {
        console.warn('ERROR AT TRACKING OBJECT: ' + err);
      }
    }
  }

  function send(form) {
    const method = form.getAttribute('method');
    const url = form.getAttribute('action');
    const data = getFormElements(form);

    sendSuccessTrackingObject(false);

    let beforeSend = function () {
      $signUpProcessing.classList.add('show');
      $signUpBody.classList.add('hide');
    };

    const request = new XMLHttpRequest();
    request.open(method, url, true);
    request.onload = function (data) {
      const response = JSON.parse(data.currentTarget.response);

      if (response.Status === 'success') {
        sendSuccessTrackingObject(true);
      }

      $signUpProcessing.classList.remove('show');
      $signUpResponseCopy.innerHTML += response.Message;
      $signUpResponse.classList.add('show');
    };
    request.setRequestHeader('Content-Type', 'application/json');
    beforeSend();
    request.send(data);
  }

  function getFormElements(form) {
    var dataJSON = {};
    dataJSON.checkboxes = [];

    const formElements = form.elements;
    Array.prototype.forEach.call(formElements, function (element) {
      if (element.nodeName === 'INPUT') {
        if (element.type === 'checkbox') {
          var checkboxElement = {};
          checkboxElement.name = element.name;
          checkboxElement.value = element.checked;
          dataJSON.checkboxes.push(checkboxElement);

          if (element.hasAttribute(formCheckboxTracking) && element.checked) {
            var stringObject = element.getAttribute(formCheckboxTracking);
            var checkboxTracking = JSON.parse(stringObject.split("'").join('"'));

            if (!$dynamicModelTracking) {
              $dynamicModelTracking = checkboxTracking;
            } else {
              $dynamicModelTracking.Model.model_name += ';' + checkboxTracking.Model.model_name;

              if (!$dynamicModelTracking.Model.model_year.includes(checkboxTracking.Model.model_year)) {
                $dynamicModelTracking.Model.model_year += ';' + checkboxTracking.Model.model_year;
              }

              if (!$dynamicModelTracking.Model.body_style.includes(checkboxTracking.Model.body_style)) {
                $dynamicModelTracking.Model.body_style += ';' + checkboxTracking.Model.body_style;
              }
            }

          }
        } else {
          dataJSON[element.name] = element.value;
        }
      }
    });

    return JSON.stringify(dataJSON);
  }

  function onSubmit(e) {
    e.preventDefault();
    var success = Validation.validateForm(e);
    Utility.log('onSubmit submission', e);

    // validate zip code
    if (ValidateZipCode()) {
      let successZipCode = function () {
        $signUpZipCodeFieldError.innerText = '';

        if ($signUpZipCodeField.classList.contains(fieldErrorClass)) {
          $signUpZipCodeField.classList.remove(fieldErrorClass);
        }

        if (success) {
          send(e.target);
        }
      };

      let errorZipCode = function () {
        var errorMsj = $signUpZipCodeInput.getAttribute(errorFieldAttr);
        $signUpZipCodeFieldError.innerText = errorMsj;

        if (!$signUpZipCodeField.classList.contains(fieldErrorClass)) {
          $signUpZipCodeField.classList.add(fieldErrorClass);
        }
      };

      Utility.validateZipcode($signUpZipCodeInput.value, successZipCode, errorZipCode);
    } else if (success) {
      send(e.target);
    }
  }

  function ValidateZipCode() {
    var validateZipCode = false;

    if (!$signUpZipCodeInput) {
      return validateZipCode;
    }

    if ($signUpZipCodeInput.value !== '') {
      validateZipCode = true;
    }

    return validateZipCode;
  }

  function OnChangeCheckbox(evt) {
    var checkbox = evt.target;
    var dataConditionRequired = checkbox.getAttribute(conditionalRequiredAttr);
    var inputRequiredIds = dataConditionRequired.split(',');

    inputRequiredIds.forEach(function (inputId) {
      var inputRequired = document.getElementById(inputId);
      if (inputRequired) {
        var hasRequiredCount = inputRequired.hasAttribute(conditionalRequiredCountAttr);
        var isRequired = inputRequired.hasAttribute(requiredAttr);
        if (isRequired && !hasRequiredCount) {
          return;
        }

        var countRequired = hasRequiredCount ? inputRequired.getAttribute(conditionalRequiredCountAttr) : 0;
        if (checkbox.checked) {
          inputRequired.classList.add(requiredClass);
          inputRequired.setAttribute(requiredAttr, requiredAttr);
          countRequired++;
          inputRequired.setAttribute(conditionalRequiredCountAttr, countRequired);
        } else {
          countRequired--;
          if (countRequired === 0) {
            inputRequired.classList.remove(requiredClass);
            inputRequired.removeAttribute(requiredAttr);
            inputRequired.removeAttribute(conditionalRequiredCountAttr);
          } else {
            inputRequired.setAttribute(conditionalRequiredCountAttr, countRequired);
          }
        }
      }
    });
  }

  function initSelectors(element) {
    $signUp = element;
    $signUpForm = $signUp.querySelector(formSelectorClass);
    $signUpBody = $signUp.querySelector(bodySelectorClass);
    $signUpProcessing = $signUp.querySelector(processingSelectorClass);
    $signUpResponse = $signUp.querySelector(responseSelectorClass);
    $signUpResponseCopy = $signUpResponse.querySelector(responseCopySelectorClass);
    $signUpFormInputs = $signUpForm.querySelectorAll(inputSelectorClass);
    $signUpFormCheckboxes = $signUpForm.querySelectorAll(checkboxSelectorClass);
    $signUpSubmitBtn = $signUp.querySelector(submitBtnSelectorClass);
  }

  function bindEvents() {
    $signUpFormInputs.forEach(function (inputText) {
      inputText.addEventListener('keypress', Validation.onKeypress);
      inputText.addEventListener('keyup', Validation.onKeyup);
      inputText.addEventListener('focus', Validation.onFocus);
      inputText.addEventListener('blur', Validation.onBlur);

      if (inputText.getAttribute('data-regexkey') === zipCodeRegex) {
        $signUpZipCodeInput = inputText;
        $signUpZipCodeField = $signUpZipCodeInput.parentElement;
        $signUpZipCodeFieldError = $signUpZipCodeField.querySelector(fieldErrorMessage);
      }
    });

    $signUpFormCheckboxes.forEach(function (checkbox) {
      var dataConditionRequired = checkbox.getAttribute(conditionalRequiredAttr);
      if (dataConditionRequired) {
        var checkboxElement = document.getElementById(checkbox.id);
        checkboxElement.addEventListener('change', OnChangeCheckbox, false);
      }
    });

    $signUpForm.addEventListener('submit', onSubmit);
  }

  function init(element) {
    initSelectors(element);
    bindEvents(element);
  }

  return {
    init: init,
  };
};
